window.addEventListener('load', () => {
    const searchDOM = document.querySelector('#input-search-map');
    const addressesDOMList = document.querySelectorAll('.bc-collection__item.map__item');
    // const mapsDOM = document.querySelector('.container__maps');

    const applyAdressFilter = () => {
        const inputValue = searchDOM.value && searchDOM.value.length > 3 ? searchDOM.value : '';
        const query = (inputValue).normalize('NFD').replace(/[\u0300-\u036f]/g, '').replaceAll(' ','').toLowerCase();
        searchDOM.setAttribute('data-query', query);
        addressesDOMList.forEach((address) => {
            const _query = address.getAttribute('data-query').toLowerCase();
            const display = query ? (_query ? (_query.includes(query) ? 'block' : 'none') : 'none' ) : 'block';
            address.style.display = display;
        });
    }
    
    // const openMap = (el) => {
    //     const slug = el.getAttribute('data-slug').toLowerCase();
    //     mapsDOM.querySelectorAll('iframe').forEach((map) => {
    //         const _slug = map.getAttribute('data-slug').toLowerCase();
    //         map.style.display = _slug == slug ? 'block' : 'none';
    //     });
    // }

    searchDOM.addEventListener('keyup', applyAdressFilter);

    // addressesDOMList.forEach((el) => {
    //     el.addEventListener('click', (el) => openMap)
    // });

    if(searchDOM.value) {
        applyAdressFilter();
        setTimeout(() => {
            Array.from(addressesDOMList).every(el => {
                if(el.style.display == 'block') {
                    el.click();
                    return false;
                }
                return true;
            });
        }, 150);
    }
})